import { COBStep, getCommonReachableSteps } from "../ClientOnboarding.common.utils";

/**
 * Gradient style for primary background. Uses CSS variables (--bg-gradient-color-1, --bg-gradient-color-2)
 * when set by CobBrandingProvider so that live branding changes in the panel (e.g. primary background)
 * are reflected in V2; falls back to the provided branding values otherwise.
 * 315deg: color2 (deeper purple) at top-left, color1 at bottom-right.
 */
export function getVendorGradientStyle(branding) {
  return {
    background: "linear-gradient(315deg, var(--bg-gradient-color-2, ".concat(branding.backgroundGradientEnd, ") 0%, var(--bg-gradient-color-1, ").concat(branding.backgroundGradientStart, ") 100%)")
  };
}

/**
 * Returns the reachable inner steps for V2 client onboarding.
 * Starts with 'introduction' (instead of 'welcome' which is the cover page in V2).
 * Excludes 'allSet' as V2 handles that transition separately.
 */
export function getReachableInnerSteps(relationship) {
  return [COBStep.introduction, ...getCommonReachableSteps(relationship)];
}
export function getNextStepButtonText(step, relationship) {
  const reachableSteps = getReachableInnerSteps(relationship);
  const currentStepIndex = reachableSteps.indexOf(step);
  if (currentStepIndex === -1) {
    return 'Next';
  }
  const nextStep = reachableSteps[currentStepIndex + 1];
  if (!nextStep) {
    return 'Sign & approve';
  }
  if (nextStep === COBStep.selectAPackage) {
    return 'Select a package';
  }
  if (nextStep === COBStep.paymentMethod) {
    return 'Add a payment method';
  }
  return 'Next';
}